<!--begin::Form-->
<form
  class="form w-100"
  [formGroup]="form"
  novalidate="novalidate"
  id="kt_login_signin_form"
>
  <!--begin::Heading-->
  <div class="text-center mb-11">
    <h1 class="text-dark fw-bolder mb-3">Acesse sua conta</h1>
    <!--begin::Subtitle-->
    <!-- <div class="text-gray-500 fw-semibold fs-6">Your Social Campaigns</div> -->
    <!--end::Subtitle--->
    <!-- <div class="text-gray-400 fw-bold fs-4">
      New Here?
      <a
        routerLink="/auth/registration"
        id="kt_login_signup"
        class="link-primary fw-bolder"
        >{{ "AUTH.GENERAL.SIGNUP_BUTTON" | translate }}</a
      >
    </div> -->
  </div>
  <!--end::Heading-->

  <!--begin::Form group-->
  <div class="fv-row mb-8">
    <label class="form-label fs-6 fw-bolder text-dark">E-mail</label>
    <input
      class="form-control bg-transparent"
      type="email"
      name="email"
      formControlName="email"
      autocomplete="off"
    />
    <app-field-control-error
      [control]="form.get('email')"
      label="E-mail"
    ></app-field-control-error>
  </div>
  <!--end::Form group-->

  <!--begin::Form group-->
  <div class="fv-row mb-3">
    <label class="form-label fw-bolder text-dark fs-6 mb-0">Senha</label>

    <input
      class="form-control bg-transparent"
      type="password"
      name="password"
      autocomplete="off"
      formControlName="password"
    />
    <app-field-control-error
      [control]="form.get('password')"
      label="Senha"
    ></app-field-control-error>
  </div>
  <!--end::Form group-->

  <!--begin::Wrapper-->
  <div class="d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8">
    <div></div>

    <!--begin::Link-->
    <a [routerLink]="['/' + companyKey + '/auth/forgot-password']" class="link-dark">
      Esqueci minha senha?
    </a>
    <!--end::Link-->
  </div>
  <!--end::Wrapper-->

  <!--begin::Action-->
  <div class="d-grid mb-10">
    <button
      type="submit"
      id="kt_sign_in_submit"
      class="btn btn-secondary"
      (click)="submit()"
      [disabled]="loading$ | async"
    >
      <ng-container *ngIf="loading$ | async">
        <span class="indicator-progress" [style.display]="'block'">
          Aguarde...
          <span
            class="spinner-border spinner-border-sm align-middle ms-2"
          ></span>
        </span>
      </ng-container>
      <ng-container *ngIf="(loading$ | async) === false">
        <span class="indicator-label">Entrar</span>
      </ng-container>
    </button>
  </div>

  <!-- <div class="text-gray-500 text-center fw-semibold fs-6">
    Not a Member yet?

    <a routerLink="/auth/registration" class="link-primary"> Sign up </a>
  </div> -->

  <!--end::Action-->
</form>
<!--end::Form-->
